<template>
<div>
    <main class="page">
        <section class="container clean-block clean-catalog dark">
                <div class="block-heading">
                    <img class="img-responsive" src="../../static/assets/img/mssn.png" style="width:100px">
                    <h3>MSSN FULAFIA DIGITAL LIBRARY</h3>
                </div>
                <div class="form-group">
                  <input type="search" placeholder="Enter name of book to search" class="form-control" aria-describedby="helpId">
                </div>
                <div class="row">
                        <div v-if="errored" class="col-md-12 text-center alert alert-danger" role="alert">
                            <p style="font-size: 100px;" class="text-center">
                                <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                                </p>
                                <strong>Error:</strong> {{books}}
                        </div>
                            <div v-else-if="loading" class="text-center " style="font-size:30px">
                                    Please wait...<br><i class="fa fa-refresh fa-spin" aria-hidden="true"></i>
                            </div>
                            <div v-else :key="book.id" v-for="(book, i) in books" class="col-md-3 text-center">
                                <div v-if="i < booksToDisplay.count" :title="book.title">
                                    <div class="embed-responsive embed-responsive-1by1">
                                        <span v-html="favIcon[book.doc_type] || favIcon['other']"></span>
                                        <small style="border-radius: 15px 50px 30px;background-color: #ffffff" class="bottom-right vid-img">
                                            <i class="fa fa-pencil-square-o" aria-hidden="true"></i> {{book.author || ''}}
                                        </small>
                                    </div>
                                    <div class="card-body info">
                                        <h6 class="card-title">{{shortenName(book.title)}}</h6>
                                        <a :href="book.donloadLink" target="_blank" class="btn btn-sm btn-block btn-success">Download <i class="fa fa-download" aria-hidden="true"></i></a>
                                        <a :href="book.previewLink" target="_blank" class="btn btn-sm btn-primary btn-block">Preview <i class="fa fa-eye" aria-hidden="true"></i></a>
                                        <small>File size: {{convertToMB(book.size)}}</small>
                                        <div v-html="shareButtons(book.title, book.donloadLink)"></div>
                                        <a target="_blank" href="mailto:tasiukwaplong@gmail.com">
                                            Contact uploader <i class="fa fa-envelope" aria-hidden="true"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        <!-- </div> -->
                </div>
                <nav>
                    <ul class="pagination" v-if="(books && books.length) > booksToDisplay.count" v-show="typeof(books) === 'object'">
                        <li class="page-item active">
                            <button type="button" @click="booksToDisplay.count += 4" class="btn btn-primary btn-lg">Show more <i class="fa fa-angle-down" aria-hidden="true"></i> </button>
                        </li>
                    </ul>
                    <ul class="pagination" v-else v-show="typeof(books) === 'object'">
                        <li class="page-item active">
                            <em>That's all we have. We're glad you came this far 😊...</em>
                        </li>
                    </ul>
                </nav>
        </section>
    </main>
</div>
</template>

<script>
const axios = require('axios')
export default {
  name: 'Home',
  data () {
    return {
      errored: false,
      loading: true,
      books: [],
      booksToDisplay: {
        count: 12,
        category: ''
      },
      favIcon: {
        'PDF': '<img src="../../static/assets/img/pdf.png" class="embed-responsive-item">',
        'Excel': '<img src="../../static/assets/img/excel.png" class="embed-responsive-item">',
        'Image/Photo': '<img src="../../static/assets/img/picture.png" class="embed-responsive-item">',
        'Powerpoint': '<img src="../../static/assets/img/powerpoint.png" class="embed-responsive-item">',
        'Plain Text': '<img src="../../static/assets/img/text.png" class="embed-responsive-item">',
        'MS Word': '<img src="../../static/assets/img/word.png" class="embed-responsive-item">',
        'other': '<img src="../../static/assets/img/file.png" class="embed-responsive-item">'
      }
    }
  },
  methods: {
    shortenName: (title) => {
      if (title.trim().length >= 20) {
        return title.substring(0, 19) + ' ...'
      } else {
        let spaces = ''
        for (let i = 0; i < (31 - title.length); i++) {
          spaces += ' '
        }
        return title + spaces
      }
    },
    shareButtons: function (title, url) {
      return `Share: <a class="share-icon" target="_blank" title="share on whatsapp" data-action="share/whatsapp/share"
      href="whatsapp://send?text=Download ${title} from mssnlibrary.netlify.app: ${url}">
        <i class="fa fa-whatsapp" aria-hidden="true"></i>
    </a>
    <a class="share-icon" target="_blank" title="share book on twitter"
      href="https://twitter.com/intent/tweet?text=Download ${title} from mssnlibrary.netlify.app: ${url}">
        <i class="fa fa-twitter" aria-hidden="true"></i>
    </a>
    <a class="share-icon" target="_blank" title="share book on facebook"
      href="http://www.facebook.com/sharer/sharer.php?u=${url}">
      <i class="fa fa-facebook" aria-hidden="true"></i>
    </a>`
    },
    convertToMB: (sizeInBytes) => {
      if (!sizeInBytes || isNaN(sizeInBytes)) {
        return '-'
      }
      let sizeInMB = sizeInBytes / 1000000
      return sizeInMB.toFixed(2) + 'mb'
    }
  },
  mounted: async function () {
    // before component loads
    const API_URL = 'https://script.google.com/macros/s/AKfycbxZ-4Bk8W8tGF0iloUQRxtqWb4mrwIWLlyMSYF-1nvRlHGE1z8/exec'
    // const API_URL = 'http://localhost/mssntest/'
    const data = await axios.get(API_URL)
      .then(function (response) {
        return (response.status === 200)
          ? response : 'Unable to fetch books. try again later'
      })
      .catch(function () {
        return 'Unable to fetch books at the moment. kindly check back in  a bit'
      })
    this.loading = (data === undefined)
    this.errored = (data === undefined)
    this.books = data.data
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue